<template>
  <md-dialog
    :md-active.sync="showPurchase"
    :md-click-outside-to-close="false"
    :md-close-on-esc="false"
  >
    <md-toolbar>
      <span class="md-title">Pasar a orden de compra</span>
    </md-toolbar>
    <md-card>
      <md-card-content>
        <div class="md-layout" style="margin-left: 20px">
          <form class="md-layout-item" id="Purchase_form" @submit.prevent="sendPurchase()">
            <div class="md-layout md-gutter">
              <div class="md-layout md-gutter" style="margin-left: 20px">
                <div class="md-layout-item md-medium-size-85 context">
                  <md-field :class="validationClass('sendConditions')">
                    <label for="sendConditions">Condiciones de envio</label>
                    <md-select
                      v-model="dataPurchase.sendConditions"
                      data-vv-name="dataPurchase"
                      v-validate="modelValidations.sendConditions"
                    >
                      <md-option
                        v-for="(condition, index) in conditions"
                        :key="index"
                        :value="condition.value"
                      >{{ condition.value }}</md-option>
                    </md-select>
                  </md-field>
                </div>
                <div class="md-layout-item md-medium-size-85 contex-div">
                  <md-field :class="validationClass('expectedDelivery')">
                    <label>Días de entrega</label>
                    <md-input
                      v-model="dataPurchase.expectedDelivery"
                      md-autogrow
                      data-vv-name="dataPurchase"
                      type="number"
                      v-validate="modelValidations.expectedDelivery"
                    ></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-medium-size-85 contex-div">
                  <md-checkbox
                    v-model="dataPurchase.doesVATApply"
                    class="md-layout-item md-size-25 md-small-size-40 text-right"
                  >¿Aplica IVA?</md-checkbox>
                </div>
              </div>
            </div>
          </form>
        </div>
      </md-card-content>
    </md-card>
    <div class="md-layout" :class="`md-alignment-${vertical}-${horizontal}`">
      <md-button
        type="submit"
        form="Purchase_form"
        class="md-primary"
        :disabled="sendingPurchase"
      >Enviar</md-button>
      <md-button @click="close">Cancelar</md-button>
    </div>
  </md-dialog>
</template>

<script>
import { ImageField } from "@/components";

const modelValidations = {
  expectedDelivery: {
    required: true,
  },
  sendConditions: {
    required: true,
  },
};

export default {
  components: { ImageField },
  props: {
    showPurchase: {
      type: Boolean,
      default: () => false,
    },
    sendingPurchase: {
      type: Boolean,
      required: true,
    },
    dataPurchase: {
      type: Object,
      default: () => {},
    },
    itemQuotation: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      vertical: "center",
      horizontal: "right",
      activeButton: true,
      modelValidations,
      conditions: [
        {
          value: "LIBRE A BORDO",
        },
        {
          value: "OCURRE LOCAL",
        },
        {
          value: "A DOMICILIO",
        },
        {
          value: "CON TIRO DIRECTO",
        },
        {
          value: "DESCARGA A NO MAS DE 20 METROS",
        },
        {
          value: "CON MANIOBRAS INCLUIDAS",
        },
        {
          value: "EN SITIO ESPECIFICO DE CADENAMIENTO DE TRABAJO",
        },
        {
          value: "ENTREGA EN MOSTRADOR DE LA TIENDA",
        },
        {
          value: "OTROS",
        },
      ],
    };
  },
  methods: {
    sendPurchase() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.$emit("send", this.dataPurchase, this.itemQuotation);
        }
      });
    },
    close() {
      this.$emit("close");
    },
  },
  mounted() {
    this.watchTouched({ dataPurchase: Object.keys(modelValidations) });
  },
  computed: {
    collectedErrors() {
      return this.errors.collect();
    },
  },
};
</script>

<style lang="css" scoped>
.md-card,
.md-card-content,
.md-card-actions {
  border: none !important;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/Purchases/QuotesTracking/dialogSendPurchase.vue